'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactRedux = require('react-redux');
var _propTypes = require('prop-types');
var _message = require('@marmalade/message');
var _message2 = _interopRequireDefault(_message);
var _withFormId = require('../hocs/with-form-id');
var _withFormId2 = _interopRequireDefault(_withFormId);
var _formInfo = require('../selectors/form-info');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ScrollToError = function (_Component) {
  _inherits(ScrollToError, _Component);
  function ScrollToError() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck(this, ScrollToError);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ScrollToError.__proto__ || Object.getPrototypeOf(ScrollToError)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showError: false
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(ScrollToError, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(lastProps) {
      if (lastProps.validating && !this.props.validating && !this.props.isValidAndPristine) {
        this.setState({
          showError: true
        });
        this.mainError.scrollIntoView();
        return;
      }
      if (this.props.forceShowState && !lastProps.forceShowState) {
        this.setState({
          showError: true
        });
        this.mainError.scrollIntoView();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;
      var showError = this.props.forceShowState === 'undefined' ? this.state.showError : this.props.forceShowState;
      return _react2.default.createElement('div', {
        // eslint-disable-next-line
        ref: function ref(element) {
          _this2.mainError = element;
          return element;
        }
      }, showError ? _react2.default.createElement(_message2.default, {
        type: 'error'
      }, this.props.message) : null);
    }
  }]);
  return ScrollToError;
}(_react.Component);
ScrollToError.propTypes = {
  formId: _propTypes.string.isRequired,
  validating: _propTypes.bool.isRequired,
  isValidAndPristine: _propTypes.bool.isRequired,
  message: _propTypes.node,
  forceShowState: _propTypes.bool
};
ScrollToError.defaultProps = {
  message: _react2.default.createElement('span', null, 'We\'ve noticed some errors on the form. Please correct the fields marked below to proceed.'),
  forceShowState: undefined
};
exports.default = (0, _withFormId2.default)((0, _reactRedux.connect)(function (state, ownProps) {
  return {
    validating: !!(0, _formInfo.isSubmittingForm)(state, ownProps.formId),
    isValidAndPristine: !!(0, _formInfo.isValidAndPristine)(state, ownProps.formId)
  };
})(ScrollToError));